<template>
  <b-form @submit.prevent="submitForm">
    <b-form-group label-for="input-code">
      <template v-slot:label>{{ $t("featureCode") }} <span class="text-danger">(*)</span></template>
      <b-form-input
        id="input-code"
        v-model = "code"
        minlength="2"
        maxlength="100"
        required
      />
    </b-form-group>
    <b-form-group label-for="input-config">
      <template v-slot:label>{{ $t("featureName") }} <span class="text-danger">(*)</span></template>
      <b-form-input
        id="input-config"
        v-model = "name"
        minlength="2"
        maxlength="200"
        required
      />
    </b-form-group>
    <b-form-group>
      <template v-slot:label>{{ $t("description") }} <span class="text-danger">(*)</span></template>
      <b-form-textarea v-model="description" rows="3" minlength="2" maxlength="500" required />
    </b-form-group>
    <div v-if="formErrorMsg" class="text-danger my-2" v-html="formErrorMsg"></div>
    <b-form-checkbox v-model="isDefault">
      {{ $t("defaultTurnOn") }}
    </b-form-checkbox>

    <div class="text-right pt-3">
      <b-button type="button" variant="secondary" class="mr-3" @click="onClickCancel" :disabled="isSubmitting">{{ $t("cancel") }}</b-button>
      <b-button type="submit" variant="primary" :disabled="isSubmitting">{{ $t("createNew") }}</b-button>
    </div>
  </b-form>
</template>

<style lang="scss" scoped>

</style>

<script lang="ts">
  import {Component} from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";
  import * as featureConfigService from "@/service/featureConfigService";
import { Status } from '../enums/EnableStatus';
  @Component
  export default class CreateConfigModal extends BaseComponent {
    formErrorMsg = "";
    isSubmitting = false;
    code = "";
    name = "";
    description = "";
    isDefault: boolean = false;
    
    onClickCancel() {
        this.$bvModal.hide('create-feature-modal');
    }

    async submitForm() {
      this.formErrorMsg = "";
      this.isSubmitting = true;

      ///trim inputs
      const trimmedName = this.name.trim();
      const trimeddescription = this.description.trim();
      
      //check required fields name
      if (!trimmedName) {
        this.formErrorMsg = this.$t("nameFeatureRequired").toString();
        this.isSubmitting = false;
        return;
      }

      //check required fields description
      if (!trimeddescription) {
        this.formErrorMsg = this.$t("descriptionFeatureRequire").toString();
        this.isSubmitting = false;
        return;
      }
      try {
        const data = {
          code: this.code.trim(),
          name: trimmedName,
          description: trimeddescription,
          isDefault: this.isDefault ? Status.ENABLE : Status.DISABLE
        };
        const res = await featureConfigService.createFeatureConfig(data);
        this.toastSuccessDelay(this.$t("createSuccessful").toString());
        this.$emit("createFeature"); //load lại fetchMeeting
        this.$bvModal.hide('create-feature-modal');
      } 
      catch (e) {
        this.toastErrorOldType(e);  
      } finally {
        this.isSubmitting = false;
      }
    }
  }
</script>
